/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable default-param-last */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { TableCell, TableRow, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as Sentry from "@sentry/react";
import Switch from "@mui/material/Switch";
import tableStyle from "../../../../theme/styles/table";
import CustomTable from "../../../../components/common/new/Table/Table";
import Typography from "../../../../components/common/new/Typography/Typography";
import Modal from "../../../../components/common/Modal/Modal";
import Button from "../../../../components/common/Button";
import styles from "./OrganizationStructure.styles";
import Pagination from "../../../../components/common/new/Pagination/Pagination";
import { Constants } from "../../../../contants";
import Member from "../../../../services/api/member";
import { performOperation } from "../../../member/MemberSearch/utils";
import InputField from "../../../../components/common/new/InputField/InputField";
import { isInteger } from "../../../../utils";
import Loader from "../../../../components/common/Loader/Loader";
import SelectMemberModal from "./SelectMemberModal";
import Appointment from "../../../../services/api/appointment";

const DIRECT_APPOINTMENT_COL = [
  {
    displayName: "MEMBER ID",
    key: "memberId",
  },
  {
    displayName: "MEMBER NAME",
    key: "memberName",
  },
  {
    displayName: "MEMBER POSITION",
    key: "memberPosition",
  },
  {
    displayName: "EMAIL",
    key: "email",
  },
  {
    displayName: "Action",
    key: "action",
  },
];

function SearchResultTable({ open, onClose, appointedMembers, payload }) {
  const [searchResult, setSearchResult] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMemberData, setSelectedMemberData] = useState([]);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [isTransferred, setIsTransferred] = useState(false);

  const type = payload && payload.type ? payload.type : null;

  const toggleAlert = () => {
    setOpenAlert(false);
  };

  const resetModalState = () => {
    setIsSwitchOn(false);
    setSearchValue("");
  };

  const acceptAppointmentHandler = (memberId) => {
    const memberData = searchResult.find(
      (item) =>
        item?.memberId === memberId ||
        (item?.memberDetails && item?.memberDetails?.memberId === memberId),
    );
    setSelectedMemberId(memberId);
    setSelectedMemberData([memberData]);
    setOpenAlert(true);
  };

  const selecctPositionId = [61, 62, 90, 91, 92, 58, 63];

  const AACCommitteeType = [26, 50, 81, 93, 38, 39, 82, 83];

  // UPDATED: extra argument `switchOn`
  const handleSearch = async (
    payload,
    page = 0,
    size = Constants.DEFAULT_PAGE_SIZE,
    switchOn = isSwitchOn,
  ) => {
    try {
      setIsLoading(true);
      const { positionId, divisionId, subDivisionId } = appointedMembers[0];
      let result;

      const isAAC = AACCommitteeType.includes(positionId);
      const committeeType = isAAC ? "AAC" : "ARC";

      if (switchOn) {
        result = await Member.transferredStructureLeaders({
          ...payload,
          page,
          size,
          positionId,
          divisionId,
          subDivisionId,
          fullName: isInteger(searchValue) ? "" : searchValue,
          memberId:
            searchValue && isInteger(searchValue) ? Number(searchValue) : "",
        });
        setIsTransferred(true);
      } else {
        setIsTransferred(false);
        if (selecctPositionId?.includes(positionId)) {
          result = await Member.structureLeaders({
            ...payload,
            page,
            size,
            positionId,
            divisionId,
            subDivisionId,
            fullName: isInteger(searchValue) ? "" : searchValue,
            memberId:
              searchValue && isInteger(searchValue) ? Number(searchValue) : "",
          });
        } else if (type === "adhoc") {
          result = await Member.structureLeaders({
            ...payload,
            page,
            size,
            positionId,
            divisionId,
            subDivisionId,
            fullName: isInteger(searchValue) ? "" : searchValue,
            memberId:
              searchValue && isInteger(searchValue) ? Number(searchValue) : "",
          });
        } else {
          result = await Appointment.getAppointmentApplications({
            ...payload,
            page,
            size,
            positionId,
            divisionId,
            subDivisionId,
            fullName: isInteger(searchValue) ? "" : searchValue,
            memberId:
              searchValue && isInteger(searchValue) ? Number(searchValue) : "",
            status: "READY_FOR_APPOINTMENT",
            committeeType,
          });
        }
      }

      const { content, totalPages, totalElements } = result.data;
      setSearchResult(content);
      setCurrentPage(page);
      setTotalPages(totalPages);
      setTotalElements(totalElements);
      setSize(size);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      Sentry.captureException(err);
    }
  };

  const onPaginationClick = (page) => {
    handleSearch(payload, Number(page), size);
  };

  const onPageSizeClick = (operator) => {
    const newPageSize = performOperation(
      size,
      Constants.DEFAULT_PAGE_SIZE,
      operator,
    );
    handleSearch(payload, 0, newPageSize);
  };

  const getRows = () => {
    if (!Array.isArray(searchResult || searchResult.memberDetails)) {
      return null;
    }

    return searchResult.map((item) => (
      <TableRow style={tableStyle.tableRow}>
        <TableCell style={styles.rowStyle}>
          {item?.memberId || item?.memberDetails?.memberId || "NA"}
        </TableCell>
        <TableCell style={styles.rowStyle}>
          {item?.fullName || item?.memberDetails?.fullName || "NA"}
        </TableCell>
        <TableCell style={styles.rowStyle}>
          {item?.appliedForName || item?.memberDetails?.appliedForName || "NA"}
        </TableCell>
        <TableCell style={styles.rowStyle}>
          {item?.emailId || item?.memberDetails?.emailId || "NA"}
        </TableCell>
        <TableCell style={styles.rowStyle}>
          <Button
            variant="outlined"
            style={styles.actionBtn}
            type="submit"
            label="APPOINT"
            onClick={() =>
              acceptAppointmentHandler(
                item?.memberId || item?.memberDetails?.memberId,
              )
            }
          />
        </TableCell>
      </TableRow>
    ));
  };

  const rows = getRows();

  // UPDATED: dependencies trimmed, state clear on close
  useEffect(() => {
    if (open) {
      handleSearch(payload, 0, Constants.DEFAULT_PAGE_SIZE, false);
    } else {
      resetModalState();
      setSearchResult([]);
      setIsTransferred(false);
    }
  }, [open, payload]);

  useEffect(() => {
    if (!open) {
      setSearchValue("");
    }
  }, [open]);

  return (
    <Modal
      open={open}
      customStyle={{
        padding: "15px",
      }}
    >
      <Box style={styles.container}>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <Box
            style={{
              display: "flex",
            }}
          >
            <Typography component="p" color="#8C8C8C" weight={500} my={2}>
              Show Transfer Member
            </Typography>
            <Switch
              checked={isSwitchOn}
              onChange={(e) => {
                const {checked} = e.target;
                setIsSwitchOn(checked);
                handleSearch(payload, 0, Constants.DEFAULT_PAGE_SIZE, checked);
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Box>
          <Box>
            <IconButton>
              <CloseIcon onClick={onClose} />
            </IconButton>
          </Box>
        </Box>
        <Box style={{ display: "flex", gap: "1rem" }} />
        {open && (
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Box justifyContent="center">
              <Typography component="p" color="#8C8C8C" weight={500} my={4}>
                Eligible Members for {appointedMembers[0]?.positionName}
                {appointedMembers[0]?.divisionName && (
                  <span> of {appointedMembers[0]?.divisionName}</span>
                )}
              </Typography>
            </Box>
            <Box width="50%">
              <InputField
                value={searchValue}
                onChange={(event) => {
                  const {value} = event.target;
                  setSearchValue(value);
                  handleSearch(
                    payload,
                    0,
                    Constants.DEFAULT_PAGE_SIZE,
                    isSwitchOn,
                  );
                }}
                label="Search Member Name / ID"
              />
            </Box>
          </Box>
        )}
        <div
          style={{
            maxHeight: "65vh",
            overflow: "auto",
          }}
        >
          <CustomTable
            columnCellStyle={{ textAlign: "center" }}
            scrollable
            columns={DIRECT_APPOINTMENT_COL}
            rows={rows}
            isLoading={isLoading}
            tableBodyTheme="#F6F6F6"
            tableHeadCellStyle={{
              ...styles.tableHeadCells,
            }}
          />
        </div>
        {searchResult?.length > 0 && open ? (
          <Box style={styles.pagination}>
            <Pagination
              totalPages={totalPages}
              totalResults={totalElements}
              currentPage={currentPage}
              pageSize={size}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          </Box>
        ) : (
          <Box style={styles.emptyContainer}>
            <h1 style={styles.noDataMsg}>No Results</h1>
          </Box>
        )}
        {isLoading && <Loader />}
        {type === "adhoc" ? (
          <SelectMemberModal
            open={openAlert}
            onClose={() => {
              toggleAlert();
              onClose();
            }}
            selectedMemberData={selectedMemberData}
            appointedMembers={appointedMembers}
            selectedMemberId={selectedMemberId}
            type={type}
          />
        ) : isTransferred ? (
          <SelectMemberModal
            open={openAlert}
            onClose={() => {
              toggleAlert();
              onClose();
            }}
            selectedMemberData={selectedMemberData}
            appointedMembers={appointedMembers}
            selectedMemberId={selectedMemberId}
            type="transferred"
          />
        ) : (
          <SelectMemberModal
            open={openAlert}
            onClose={() => {
              toggleAlert();
              onClose();
            }}
            selectedMemberData={selectedMemberData}
            appointedMembers={appointedMembers}
            selectedMemberId={selectedMemberId}
          />
        )}
      </Box>
    </Modal>
  );
}

export default SearchResultTable;
